import React from 'react';

import CoproArea from '../../components/Setup/StepCoproArea';


function ActivitySetupCoproAreaView() {
  return (
    <CoproArea />
  );
}

export default ActivitySetupCoproAreaView;
